<template>
	<div class="az-container card-erro-container">
		<div class="mensagem-erro">
			<v-icon size="100" color="#FF9900" class="mb-5">error_outline</v-icon>
			<p class="texto">Ocorreu um erro na inicialização desta aplicação.</p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'erro-inicializacao',
}
</script>
<style lang="stylus" scoped>
.card-erro-container
	display flex
	justify-content center
	align-items center
	height calc(100vh - 136px)

	.mensagem-erro
		text-align center
		.texto
			font-size 30px
			color #333333
</style>
